import { EntityType } from '@frontend/common';
import { FunctionalityClient } from '@frontend/functionality/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useFunctionality:request': CustomEvent<string>;
    }
}

const REQUEST_FUNCTIONALITY_EVENT = 'useFunctionality:request';
const STORAGE_KEY = 'FUNCTIONALITY_REQ';

export function functionalityRequest(functionalityId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_FUNCTIONALITY_EVENT, { detail: functionalityId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function FunctionalityResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_FUNCTIONALITY_EVENT, EntityType.FUNCTIONALITY, (ids) => FunctionalityClient.resolveFunctionalities(ids), props.dispatch);
    return <></>;
}
